export default function addOverflowHover(el) {
  const overflowItems = [...el.querySelectorAll('.overflow-hover')].filter(
    (item) => item.scrollWidth > item.clientWidth,
  );

  overflowItems.forEach((item) => {
    const content = document.createElement('div');
    content.innerHTML = item.innerHTML;
    content.style.overflow = 'inherit';
    content.style.textOverflow = 'inherit';
    content.classList.add('overflow-hover__el');
    item.innerHTML = '';
    item.appendChild(content);

    item.removeAttribute('title');

    function show() {
      item.style.overflow = 'visible';
      content.style.position = 'relative';
      content.style.display = 'inline-block';
    }

    function hide() {
      item.style.overflow = 'hidden';
      content.style.position = 'static';
      content.style.display = 'block';
    }

    item.addEventListener('mouseover', () => {
      show();
    });

    item.addEventListener('mouseout', () => {
      hide();
    });

    item.setAttribute('tabindex', '0');

    item.addEventListener('focus', () => {
      show();
    });

    item.addEventListener('blur', () => {
      hide();
    });
  });
}
